import {
  Button,
  ButtonGroup,
  Content,
  Dialog,
  Divider,
  Heading,
  useDialogContainer,
  TextField,
  Flex,
  Text,
} from "@adobe/react-spectrum";
import React, { useState } from "react";
import { useOktaAuth } from "@okta/okta-react";
import PropTypes from "prop-types";
import {
  error as ErrorToast,
  success as SuccessToast,
} from "@react/react-spectrum/Toast";
import { gtmhApi } from "../../../../api/gtmhApi";
import useUserProfile from "../../../../context/user-context";

export default function RejectSubDialog({
  rowInfo,
  // status,
  refreshTable,
  isPageLoading,
  setPageLoading,
}) {
  const { user } = useUserProfile();
  const { authState } = useOktaAuth();

  const [rejectRequest, setRejectRequest] = useState({
    sub_id: rowInfo.sub_id,
    comment: "",
    user_id: user?.userId,
    user_name: user?.name,
    status: "in-review",
  });
  const [errorMessage, setErrorMessage] = useState("");

  const dialog = useDialogContainer();

  const handleReject = () => {
    setPageLoading(true);
    gtmhApi
      .rejectSub(rejectRequest, authState.accessToken)
      .then((data) => {
        if (data.results?.sub_id) {
          dialog.dismiss();
          refreshTable();
          setPageLoading(false);
          SuccessToast(
            `Successfully rejected ${rowInfo.sub_name} (${rowInfo.sub_id})!`,
            {
              timeout: 5000,
            }
          );
        } else {
          setPageLoading(false);
          setErrorMessage(data.results?.error_payload.message);
        }
      })
      .catch((error) => {
        console.log("error");
        dialog.dismiss();
        setPageLoading(false);
        ErrorToast(error.response?.data?.message || "Error rejecting company", {
          timeout: 5000,
        });
      });
  };

  const handleCancel = () => {
    dialog.dismiss();
  };

  return (
    <Dialog>
      <Heading>{`Reject ${rowInfo.parent ? "Parent" : "Sub"}: ${
        rowInfo.sub_name
      } (${rowInfo.sub_id})`}</Heading>
      <Divider />
      <Content>
        {errorMessage !== "" && (
          <Text UNSAFE_style={{ color: "red" }}>{errorMessage}</Text>
        )}
        <Flex marginBottom="15px">
          Rejecting this change will move the company to the rejected status.
          Proceed to reject?
        </Flex>
        <TextField
          label="Comment"
          width="100%"
          onChange={(val) =>
            setRejectRequest({ ...rejectRequest, comment: val })
          }
          marginTop="10px"
        />
      </Content>
      <ButtonGroup>
        <Button onPress={handleCancel} variant="secondary">
          Cancel
        </Button>
        <Button
          onPress={handleReject}
          color="primary"
          variant="accent"
          isDisabled={isPageLoading}
        >
          Reject
        </Button>
      </ButtonGroup>
    </Dialog>
  );
}

RejectSubDialog.propTypes = {
  rowInfo: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.array,
      PropTypes.object,
      PropTypes.arrayOf(PropTypes.object),
    ])
  ).isRequired,
  // status: PropTypes.string.isRequired,
  refreshTable: PropTypes.func.isRequired,
  setPageLoading: PropTypes.func.isRequired,
  isPageLoading: PropTypes.bool.isRequired,
};
